import { Controller } from "@hotwired/stimulus";
import { useClickOutside, useDebounce } from 'stimulus-use'

export default class extends Controller {
  static targets = ["results", "input"];
  static debounces = ["search"];
  static values = {
    url: String
  };

  connect() {
    useClickOutside(this)
    useDebounce(this) // default debounce time is 200ms
  }

  search() {
    if(this.inputTarget.value.length == 0) {
      this.clearResults()
      return
    }

    this.inputTarget.value.length > 2 && this.fetchTurboStream();
  }

  clearResults() {
    this.resultsTarget.innerHTML = ""
  }

  clickOutside() {
    this.clearResults()
  }

  selectCompany(event) {
    this.dispatch("company-selected", { detail: event.params })
    this.clearResults()
    this.fetchAdditionalData(event.params.RegistrationNumber)
  }

  fetchAdditionalData(registrationNumber) {
    if (!registrationNumber) return;

    fetch(this.urlValue + "/" + registrationNumber, { method: "GET"})
      .then(r => r.text())
      .then(html => {
        const data = JSON.parse(html)
        this.dispatch("company-selected", {
          detail: {
            RegistrationCity: data.greffe,
            Capital: data.capital,
            VatNumber: data.numero_tva_intracommunautaire
          }
        })
      })
      .catch(error => {});
  }

  urlWithParams() {
    const url = new URL(this.urlValue);
    url.searchParams.append("query", this.inputTarget.value);

    return url
  }

  fetchTurboStream() {
    if (this.signal) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()
    this.signal = this.abortController.signal

    fetch(this.urlWithParams(), {
      method: "GET",
      signal: this.signal,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => {});
  }
}
